import styled, { css } from 'styled-components';

import MaterialIcon from '@/components/atom/MaterialIcon';
import BottomSheet from '@/components/molecules/BottomSheet';
import theme from '@/styles/theme';

interface Props<T> {
  title: string;
  list: T[];
  onClick: (item: T) => void;
  getItemName: (item: T) => string;
  isSelected?: (item: T) => boolean;
  onClose: () => void;
}

const SelectBottomSheet = <T,>(props: Props<T>) => {
  const { title, list, onClick, getItemName, onClose, isSelected } = props;
  return (
    <BottomSheet isOpened={true} onClickOverlay={onClose} index={500}>
      <Wrapper>
        <FilterModalTitle>{title}</FilterModalTitle>
        <FilterList>
          {list.map((item) => (
            <Filter
              key={`filter-${getItemName(item)}`}
              onClick={() => onClick(item)}
            >
              <p>{getItemName(item)}</p>
              {isSelected && isSelected(item) && (
                <MaterialIcon
                  name="check"
                  size={32}
                  color={theme.color.primary500}
                />
              )}
            </Filter>
          ))}
        </FilterList>
      </Wrapper>
    </BottomSheet>
  );
};

export default SelectBottomSheet;

const Wrapper = styled.div`
  padding: 24px 0 32px;
`;

const FilterModalTitle = styled.p`
  ${({ theme }) => css`
    ${theme.typography.UI22SB}
    color: ${theme.color.gray900};
    padding: 0 24px;
    margin-bottom: 20px;
  `}
`;

const FilterList = styled.ul`
  max-height: 500px;
  overflow-y: scroll;
`;

const Filter = styled.li`
  ${({ theme }) => css`
    & > p {
      ${theme.typography.UI16M}
      color: ${theme.color.gray800};
    }
  `}
  height: 56px;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;
